import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>Credit & Promo Codes</ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton />
    </ExpoRouterDemoScreen>
  );
}
